import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Fragment } from "react";
const NotFound = () => {
  const location = useLocation();
  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);
  return <Fragment>
      <div className="min-h-screen flex items-center justify-center bg-gray-100/50 px-4 -mt-16">
        <Card className="max-w-lg w-full p-10">
          <CardHeader className="p-0 pb-5">
            <CardTitle className="text-4xl font-bold">404</CardTitle>
            <CardDescription className="text-xl">
              Oops! Page not found
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-4">
              <h3 className="text-lg font-medium">Discover ChronoCal</h3>
              <p className="text-muted-foreground">
                While this page doesn't exist, we'd love to show you how ChronoCal can transform your calendar into a personal operating system. Unlike traditional calendars, ChronoCal understands your natural energy rhythms and helps you optimize your day.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 pt-2">
                <Button variant="default" className="sm:flex-1" asChild>
                  <a href="/signup">Get Started Free</a>
                </Button>
                <Button variant="outline" className="sm:flex-1" asChild>
                  <a href="/">Learn More</a>
                </Button>
              </div>
            </div>
            
            <div className="space-y-3 border-t pt-6">
              <h4 className="font-medium">Popular Features:</h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>• Biology-aware scheduling that respects your peak hours</li>
                <li>• AI-powered meeting time suggestions</li>
                <li>• Plug in your wearable for hyper personalized energy forecasts</li>
                <li>• Health data integration for optimal scheduling</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </Fragment>;
};
export default NotFound;